import { useEffect, useSyncExternalStore } from "react";
import {
  ensureGuideMediaManifestLoaded,
  getGuideMediaManifestVersion,
  subscribeGuideMediaManifest,
} from "../utils/guideMediaManifest";

export default function useGuideMediaManifestVersion() {
  const version = useSyncExternalStore(
    subscribeGuideMediaManifest,
    getGuideMediaManifestVersion,
    getGuideMediaManifestVersion,
  );

  useEffect(() => {
    ensureGuideMediaManifestLoaded().catch((error) => {
      console.warn("Unable to initialize guide media manifest runtime overrides", error);
    });
  }, []);

  return version;
}
